const AnalyticsGateway = {
  /**
   * Initialize segment/mixpanel at once
   * this expect the mixpanel script is already
   * attached on the index.html
   */
  initialize: key => {
    window.analytics && window.analytics.load && window.analytics.load(key);
  },
  /**
   * This will be trigger page view
   * only in segment
   */
  pageView: function () {
    let path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    window.analytics && window.analytics.page(path);
  },
  /**
   * This will trigger event for mixpanel
   */
  trackEvent: (eventName, eventProperties) => {
    if (window.analytics) {
      window.analytics.track(eventName, eventProperties);
    }
  }
};

export { AnalyticsGateway as default };
